module.exports = __webpack_public_path__ + "static/12-40735bdaf703504f1543a3a05538a11a.jpg";